import { render } from "./PraiseListLayout.vue?vue&type=template&id=43370ec4&scoped=true"
import script from "./PraiseListLayout.vue?vue&type=script&lang=js"
export * from "./PraiseListLayout.vue?vue&type=script&lang=js"

import "./PraiseListLayout.vue?vue&type=style&index=0&id=43370ec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43370ec4"]])

export default __exports__